module.exports = __webpack_public_path__ + "static/media/Plus-red.d5237e6a.svg";